export const getRandomKey = () => {
  return (
    new Date().valueOf() +
    Math.floor(Math.random() * (Math.floor(10000) - Math.ceil(0) + 1)) +
    Math.ceil(0)
  );
};

export default {
  getRandomKey
};
